export const website = {
  title: "Titel",
  url: "URL",
  description: "Beschreibung",
  mainCategory: "Hauptkategorie",
  subCategory: "Unterkategorie",
  region: "Region",
  zipCode: "Postleitzahl",
  addedBy: "Hinzugefügt von",
  addedAt: "Hinzugefügt am",
  suggestedBy: "Vorgeschlagen von",
  suggestedAt: "Vorgeschlagen am",
  status: "Status",
  pending: "Ausstehend",
  approved: "Genehmigt",
  rejected: "Abgelehnt",
};

export const suggestWebsite = {
  title: "Website vorschlagen",
  subtitle: "Schlagen Sie eine deutsche Website für das Archiv vor",
  form: {
    websiteTitle: "Website-Titel",
    websiteTitlePlaceholder: "z.B. Bundesministerium für Bildung und Forschung",
    websiteUrl: "Website-URL",
    websiteUrlPlaceholder: "z.B. bmbf.de oder https://www.bmbf.de",
    description: "Beschreibung",
    descriptionPlaceholder: "Kurze Beschreibung der Website und ihres Zwecks",
    selectMainCategory: "Hauptkategorie wählen",
    selectSubCategory: "Unterkategorie wählen",
    region: "Region",
    regionPlaceholder: "z.B. Bayern, Nordrhein-Westfalen",
    zipCode: "Postleitzahl (aus Impressum)",
    zipCodePlaceholder: "z.B. 10115",
  },
  button: "Website vorschlagen",
  success: "Website erfolgreich vorgeschlagen",
  successDescription:
    "Ihre Websiteempfehlung wird von unseren Kuratoren geprüft.",
};

export const addWebsite = {
  title: "Website hinzufügen",
  subtitle: "Fügen Sie eine neue Website zum Archiv hinzu",
  button: "Website hinzufügen",
  success: "Website erfolgreich hinzugefügt",
  successDescription: "Die Website wurde dem Archiv hinzugefügt.",
};

export const editWebsite = {
  title: "Website bearbeiten",
  button: "Änderungen speichern",
  success: "Website erfolgreich aktualisiert",
};

export const manageWebsites = {
  title: "Websites verwalten",
  subtitle: "Verwalten Sie Ihre hinzugefügten Websites",
  addNew: "Neue Website",
  myWebsites: "Meine Websites",
  suggestions: "Website-Vorschläge",
  searchPlaceholder: "Websites durchsuchen...",
  noWebsites: "Noch keine Websites hinzugefügt",
  noWebsitesDescription:
    "Beginnen Sie mit dem Hinzufügen von Websites zum Archiv.",
  deleteConfirm: "Website löschen",
  deleteDescription: "Diese Aktion kann nicht rückgängig gemacht werden.",
  approve: "Genehmigen",
  reject: "Ablehnen",
};

export const websiteSuggest = {
  title: "Website vorschlagen",
  subtitle: "Schlagen Sie eine Website für das Archiv vor",
  infoAsRegistered:
    "Als registrierter Nutzer können Sie Vorschläge für neue Websites einreichen.",
  infoAsAnonymous:
    "Als anonymer Nutzer können Sie Vorschläge für neue Websites einreichen.",
  infoRegisteredCanAdd:
    'Als registrierter Nutzer können Sie Websites auch direkt über die Funktion "Website hinzufügen" im Menü "Verwalten" hinzufügen.',
  infoAnonymousReview:
    "Ihre Vorschläge werden von registrierten Nutzern geprüft und gegebenenfalls aufgenommen.",
  websiteInfo: "Website-Informationen",
  websiteInfoDesc:
    "Bitte geben Sie alle erforderlichen Informationen zur vorgeschlagenen Website an",
  titleLabel: "Titel der Webseite *",
  titlePlaceholder: "z.B. Max-Planck-Institut für Physik",
  urlLabel: "URL der Webseite *",
  urlPlaceholder: "example.de, www.example.de oder https://www.example.de",
  urlHint:
    "Sie können die URL in verschiedenen Formaten eingeben (z.B. example.de, www.example.de)",
  /**
   * Optionales Adressfeld (Suggest-Website-Formular).
   * Wird in WebsiteSuggest.tsx verwendet (Keys: websiteSuggest.addressLabel/addressPlaceholder).
   */
  addressLabel: "Adresse (optional)",
  addressPlaceholder: "z.B. Musterstraße 1, 94032 Passau",
  addressAutoPlaceholder:
    "Adresse, Ort, Landkreis oder Bundesland eingeben (Deutschland)",
  addressAutoHint:
    "Vorschläge erscheinen während der Eingabe. Bitte wählen Sie einen Treffer aus, um die Region vorzubelegen. Die Suche ohne Hausnummern funktioniert oft besser.",
  addressAutoNoResults: "Keine Treffer gefunden.",
  addressAutoUnavailable:
    "Die automatische Regionszuordnung ist derzeit nicht verfügbar. Sie können manuell fortfahren.",
  addressAutoDisabled:
    "Die Adress-Autovervollständigung ist in den Systemeinstellungen deaktiviert. Sie können manuell fortfahren.",
  loadingShort: "Lädt",
  addressConfidenceExact: "Adresse eindeutig erkannt",
  addressConfidencePartial: "Region erkannt",
  addressConfidenceState: "Bundesland erkannt",
  addressConfidenceAdminDistrict: "Regierungsbezirk erkannt",
  addressConfidenceDistrict: "Kreis erkannt",
  addressConfidenceAmbiguous: "Mehrere Treffer – bitte auswählen",
  descriptionLabel: "Kurzbeschreibung *",
  descriptionPlaceholder:
    "Beschreiben Sie kurz den Inhalt und Zweck der Website...",
  charactersCount: "{count} / 500 Zeichen",
  category1Label: "Kategorie (optional)",
  category1Placeholder: "Kategorie auswahlen",

  categorySelected: "Kategorie ausgewählt",
  clearManualCategory: "Auswahl löschen",
  categoryPathPrefix: "Kategorie:",
  categoryRootLabel: "Alle Kategorien",
  categoryBrowseChildren: "Unterkategorien",
  categoryNavigatorHint: "Klicken Sie auf einen Kategorienamen, um ihn zu übernehmen. Mit dem Pfeil rechts öffnen Sie tiefere Ebenen.",

  noCategory1Found: "Keine Kategorie gefunden.",

  category1LoadFailed: "Kategorie konnte nicht geladen werden.",
  loading: "Lädt...",
  reachedLeaf: "Keine tieferen Kategorien auf dieser Ebene verfügbar.",

  mainCategoryLabel: "Hauptkategorie (optional)",
  mainCategoryPlaceholder: "Kategorie suchen...",
  subCategoryLabel: "Unterkategorie (optional)",
  subCategoryPlaceholder: "Unterkategorie suchen...",
  noCategoryFound: "Keine Kategorie gefunden.",
  noSubcategoryFound: "Keine Unterkategorie gefunden.",
  selectedCategorization: "Gewählte Kategorisierung:",
  zipCodeLabel: "Postleitzahl (optional)",
  zipCodePlaceholder: "z.B. 10115",
  zipCodeHint: "",
  regionLabel: "Region/Bundesland (optional)",
  regionPlaceholder: "z.B. Bayern, Nordrhein-Westfalen",
  regionHint: "",
  regionPathPrefix: "Region:",
  regionLoadFailed: "Regionen konnten nicht geladen werden.",
  noRegionFound: "Keine Region gefunden.",
  submitButton: "Vorschlag einreichen",
  cancel: "Abbrechen",
  fillAllFields: "Bitte füllen Sie alle Pflichtfelder aus",
  // The following three keys are used for validation error messages in WebsiteSuggest.tsx.
  errorTitleRequired:
    "Der Titel darf nicht leer sein, sonst kann der Vorschlag nicht abgeschickt werden.",
  errorUrlRequired:
    "Die URL darf nicht leer sein, sonst kann der Vorschlag nicht abgeschickt werden.",
  errorDescriptionRequired:
    "Die Beschreibung darf nicht leer sein, sonst kann der Vorschlag nicht abgeschickt werden.",
  // Length limit.
  errorDescriptionTooLong:
    "Die Beschreibung darf höchstens {max} Zeichen lang sein.",
  errorTitleTooLong: "Der Titel darf höchstens {max} Zeichen lang sein.",
  errorUrlTooLong: "Die URL darf höchstens {max} Zeichen lang sein.",
  errorAddressTooLong: "Die Adresse darf höchstens {max} Zeichen lang sein.",
  errorZipTooLong: "Die Postleitzahl darf höchstens {max} Zeichen lang sein.",

  // URL error messages (used in WebsiteSuggest.tsx)
  errorUrlExists: "Diese URL existiert bereits.",
  errorUrlVerifyFailed:
    "URL konnte nicht geprüft werden. Bitte versuche es erneut.",
  successTitle: "Vorschlag erfolgreich eingereicht!",
  successMessage:
    "Ihr Website-Vorschlag wurde erfolgreich eingereicht und wird nun von registrierten Nutzern geprüft.",
  website: "Website",
  url: "URL",
  category: "Kategorie",
  unknown: "Unbekannt",
  done: "Fertig",
  back: "Zurück",
  clearSelection: "Auswahl löschen",
  successRegisteredInfo:
    "Sie können den Status Ihrer Vorschläge in der Website-Verwaltung einsehen.",
  successAnonymousInfo:
    "Vielen Dank für Ihren Beitrag zum WebKurator.de Archiv!",
  understood: "Verstanden",
  goToManagement: "Zur Verwaltung",

  submitSuccess: "Vorschlag erfolgreich eingereicht.",
  submitError: "Vorschlag konnte nicht eingereicht werden.",

  //AI button
  aiCategoryLabel: "KI-gestützte Kategorienvorschläge",
  aiSuggestButton: "Mit KI vorschlagen",
  aiSuggesting: "KI macht einen Vorschlag...",
  aiClearButton: "KI-Auswahl zurücksetzen",
  aiApplied: "Die KI-Kategorie wurde erfolgreich übernommen.",
  aiLockedHint: "Die Kategorie wurde von der KI gesetzt. Sie können sie zurücksetzen und manuell auswählen.",
  aiResultPrefix: "KI-Vorschlag:",
  aiNeedTitleAndDescription: "Bitte geben Sie Titel, URL und Beschreibung ein, bevor die KI-Kategorisierung verfügbar ist.",
  aiTimeout: "Der KI-Dienst hat nicht rechtzeitig geantwortet. Bitte versuchen Sie es später erneut.",
  aiBadGateway: "Der KI-Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.",
  aiFailed: "Die KI-Kategorievorschlag ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  geocodingBadGateway:
    "Der Adressdienst ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut."
};

export const websiteManagement = {
  title: "Website-Verwaltung",
  subtitle: "Websites hinzufügen, bearbeiten und Vorschläge verwalten",
  tabAdd: "Website hinzufügen",
  tabManage: "Websites bearbeiten",
  tabSuggestions: "Vorschläge",
  addWebsiteTitle: "Neue Website hinzufügen",
  addWebsiteDesc:
    "Fügen Sie eine neue Website direkt zum Archiv hinzu (ohne Prüfung)",
  titleLabel: "Titel der Webseite *",
  titlePlaceholder: "z.B. Max-Planck-Institut",
  urlLabel: "URL *",
  urlPlaceholder: "example.de, www.example.de oder https://...",
  urlHint: "Verschiedene Formate werden akzeptiert",
  descriptionLabel: "Beschreibung *",
  descriptionPlaceholder: "Beschreibung der Website...",
  addressLabel: "Adresse (optional)",
  mainCategoryLabel: "Hauptkategorie *",
  mainCategoryPlaceholder: "Kategorie suchen...",
  subCategoryLabel: "Unterkategorie (optional)",
  subCategoryPlaceholder: "Unterkategorie suchen...",
  noCategoryFound: "Keine Kategorie gefunden.",
  noSubcategoryFound: "Keine Unterkategorie gefunden.",
  zipCodeLabel: "Postleitzahl (optional)",
  zipCodePlaceholder: "z.B. 10115",
  zipCodeHint: "Die Region wird automatisch aus der PLZ ermittelt",
  regionLabel: "Region/Bundesland *",
  regionPlaceholder: "z.B. Bayern, Nordrhein-Westfalen",
  regionHint: "Automatisch ausgefüllt, kann aber angepasst werden",
  zipRegionMismatch: "PLZ passt nicht zum Bundesland.",
  addButton: "Website hinzufügen",
  cancel: "Abbrechen",
  fillAllFields: "Bitte füllen Sie alle Pflichtfelder aus",
  categoryRequiredError: "Bitte wählen Sie eine Kategorie aus.",
  regionRequiredError:
    "Bitte wählen Sie eine Region oder geben Sie eine Postleitzahl ein.",
  manageWebsitesTitle: "Websites bearbeiten",
  manageWebsitesDesc: "Bearbeiten oder löschen Sie bestehende Websites",
  searchPlaceholder: "Websites durchsuchen...",
  filter: "Filter",
  tableTitle: "Titel",
  tableCategory: "Kategorie",
  tableLocation: "Standort",
  tableAdded: "Hinzugefügt",
  tableActions: "Aktionen",
  editButton: "Bearbeiten",
  deleteButton: "Löschen",
  deleteConfirmTitle: "Website löschen",
  deleteConfirmDescription: 'öchten Sie "{title}" wirklich löschen',
  deleteTitle: "Website löschen",
  deleteDescription: 'Möchten Sie "{title}" wirklich löschen',
  deleteAdminNote: " Diese Aktion kann rückgängig gemacht werden.",
  delete: "Löschen",
  websiteDeleted: '"{title}" wurde gelöscht',
  websiteUpdated: "Website erfolgreich aktualisiert",
  suggestionsTitle: "Vorschläge prüfen",
  suggestionsDesc:
    "Prüfen Sie Vorschläge von anderen Nutzern und entscheiden Sie über deren Aufnahme",
  noSuggestions: "Keine offenen Vorschläge",
  suggestedBy: "Vorgeschlagen von: {name} am {date}",
  approveButton: "Genehmigen",
  editAndApproveButton: "Bearbeiten & Genehmigen",
  rejectButton: "Ablehnen",
  reject: "Ablehnen",
  suggestionApproved: "Vorschlag wurde genehmigt",
  suggestionApprovedWithChanges: "Vorschlag wurde mit Änderungen genehmigt",
  suggestionRejected: "Vorschlag wurde abgelehnt",
  editWebsiteTitle: "Website bearbeiten",
  editWebsiteDesc: "Website-Details aktualisieren und Änderungen speichern",
  editSuggestionTitle: "Vorschlag bearbeiten",
  editSuggestionDesc:
    "Nehmen Sie Änderungen vor und genehmigen Sie den Vorschlag oder speichern Sie ihn",
  titleField: "Titel",
  urlField: "URL",
  descriptionField: "Beschreibung",
  mainCategoryField: "Hauptkategorie",
  subCategoryField: "Unterkategorie",
  search: "Suchen...",
  save: "Speichern",
  approveWithChanges: "Bearbeiten & genehmigen",
  saveSuggestionEdits: "Änderungen speichern",
  suggestionSaved: "Vorschlag wurde gespeichert",
  successAddTitle: "Website erfolgreich hinzugefügt!",
  successAddMessage:
    "Die Website wurde erfolgreich zum Archiv hinzugefügt und ist sofort verfügbar.",
  website: "Website",
  category: "Kategorie",
};

